import React, { useState } from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import './DisclaimerModal.css';

const DisclaimerModal = ({ isOpen, onAccept, onCancel }) => {
  const t = useTranslation();
  const [isChecked, setIsChecked] = useState(false);

  if (!isOpen) return null;

  const handleAccept = () => {
    if (isChecked) {
      onAccept();
    }
  };

  const handleCancel = () => {
    setIsChecked(false);
    onCancel();
  };

  return (
    <div className="disclaimer-modal-overlay" onClick={handleCancel}>
      <div className="disclaimer-modal" onClick={(e) => e.stopPropagation()}>
        <div className="disclaimer-modal-header">
          <h2>{t('creditPlanFlow.disclaimerModal.title')}</h2>
          <button 
            className="disclaimer-close-button" 
            onClick={handleCancel}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        
        <div className="disclaimer-modal-body">
          <div className="disclaimer-content">
            <p className="disclaimer-intro">
              <strong>{t('creditPlanFlow.disclaimerModal.importantNotice')}</strong> {t('creditPlanFlow.disclaimerModal.intro')}
            </p>
            
            <div className="disclaimer-points">
              <div className="disclaimer-point">
                <span className="point-icon">🤖</span>
                <div>
                  <strong>{t('creditPlanFlow.disclaimerModal.aiGeneratedTitle')}</strong>
                  <p>{t('creditPlanFlow.disclaimerModal.aiGeneratedBody')}</p>
                </div>
              </div>
              
              <div className="disclaimer-point">
                <span className="point-icon">⚠️</span>
                <div>
                  <strong>{t('creditPlanFlow.disclaimerModal.mayContainErrorsTitle')}</strong>
                  <p>{t('creditPlanFlow.disclaimerModal.mayContainErrorsBody')}</p>
                </div>
              </div>
              
              <div className="disclaimer-point">
                <span className="point-icon">🔍</span>
                <div>
                  <strong>{t('creditPlanFlow.disclaimerModal.verifyInformationTitle')}</strong>
                  <p>{t('creditPlanFlow.disclaimerModal.verifyInformationBody')}</p>
                </div>
              </div>
              
              <div className="disclaimer-point">
                <span className="point-icon">👨‍💼</span>
                <div>
                  <strong>{t('creditPlanFlow.disclaimerModal.professionalAdviceTitle')}</strong>
                  <p>{t('creditPlanFlow.disclaimerModal.professionalAdviceBody')}</p>
                </div>
              </div>
            </div>
            
            <div className="disclaimer-note">
              <p>
                {t('creditPlanFlow.disclaimerModal.note')}
              </p>
            </div>
          </div>
          
          <div className="disclaimer-acceptance">
            <label className="disclaimer-checkbox-label">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                className="disclaimer-checkbox"
              />
              <span>
                {t('creditPlanFlow.disclaimerModal.checkboxText')}
              </span>
            </label>
          </div>
        </div>
        
        <div className="disclaimer-modal-footer">
          <button 
            className="disclaimer-btn-cancel" 
            onClick={handleCancel}
          >
            {t('creditPlanFlow.disclaimerModal.cancel')}
          </button>
          <button 
            className="disclaimer-btn-accept" 
            onClick={handleAccept}
            disabled={!isChecked}
          >
            {t('creditPlanFlow.disclaimerModal.acceptAndContinue')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerModal;

